module.exports = __webpack_public_path__ + "assets/img/1881591928117_.pic_hd.e8a0d19c.jpg";